import type { FC } from 'react'
import styles from './FloatingButton.module.scss'
import { useLocalisation } from '@/tools/i18n/client'
import {
  ChevronBackwardIcon,
  CrossIcon,
  IconButton,
  IconButtonSize,
  IconButtonVariants,
} from '@/tools/ui'
import { useAddressBookContext } from '@/user/address-book/AddressBookContext'
import type { FloatingButtonVariant } from '@/user/address-book/types'

interface Props {
  variant: FloatingButtonVariant
}

export const FloatingButton: FC<Props> = ({ variant }) => {
  const { t } = useLocalisation()
  const { navigate, closeAddressBook } = useAddressBookContext()

  const handleClick = () => {
    if (variant === 'BACK') {
      navigate('onBack')
    }
    if (variant === 'CLOSE') {
      closeAddressBook()
    }
  }

  const icon = variant === 'CLOSE' ? CrossIcon : ChevronBackwardIcon
  const ariaLabel = variant === 'CLOSE' ? t('common.close') : t('glovo.common.back')

  return (
    <IconButton
      aria-label={ariaLabel}
      className={styles.backButton}
      icon={icon}
      size={IconButtonSize.small}
      variant={IconButtonVariants.floating}
      onClick={handleClick}
    />
  )
}
